exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.diy-notice-icon, .diy-notice-icon img{ width: 32px; height: 32px;\n}\r\n", "", {"version":3,"sources":["/Volumes/aigoWork/Workspace/ying-zheng/yz-server/front_end/jjj_shop_multi_shop/src/views/page/page/diy/params/Notice.vue"],"names":[],"mappings":";AACA,wCAAwC,YAAY,CAAC,aAAa;CACjE","file":"Notice.vue","sourcesContent":["\n.diy-notice-icon, .diy-notice-icon img{ width: 32px; height: 32px;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1c7392d1","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/page/page/diy/params/Notice.vue
// module id = nzbl
// module chunks = 0